import { render } from "./ImpactCard.vue?vue&type=template&id=347fc700&scoped=true"
import script from "./ImpactCard.vue?vue&type=script&lang=js"
export * from "./ImpactCard.vue?vue&type=script&lang=js"

import "./ImpactCard.vue?vue&type=style&index=0&id=347fc700&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347fc700"]])

export default __exports__